module.exports = __webpack_public_path__ + "static/media/btnFirst.6fdda047.svg";